import {NgModule} from "@angular/core";
import {DraggableItemComponent} from "app/shared/components/DraggableItem/DraggableItem.component";

@NgModule({
    declarations: [DraggableItemComponent],
})
export class DraggableItemModule {
}
